@if(content){
@if(content?.overline || content?.title || content?.paragraph || content?.buttons.length){
<div class="flex flex-column"
     [ngClass]="{'flex-middle center': contentAlign === 'center', 'flex-bottom right' : contentAlign === 'right', 'flex-top left' : contentAlign === 'left',  'col-w' : variant === 'light'}">
    <div class="o1 m-b-1 skipEmpty"
         [ngClass]="content.overlineColor"
         *iCms="'overline' of content; content: 'html'"></div>
    <div class="m-b-2 skipEmpty"
         [ngClass]="content.titleColor + ' ' + (content?.titleClass || 'h1')"
         *iCms="'title' of content; content: 'html'"></div>
    <div class="p1 m-b skipEmpty"
         [ngClass]="content.paragraphColor || (variant === 'light' ? 'col-w' : 'col-11')"
         *iCms="'paragraph' of content; content: 'html'"></div>

    @if(content.buttons?.length){
    <div class="flex flex-wrap"
         [class.flex-justify-center]="contentAlign === 'center'"
         [class.flex-justify-end]="contentAlign === 'right'"
         [class.flex-justify-start]="contentAlign === 'left'"
         [style.gap]="'8px'">
        @for (button of content.buttons; track $index) {
        <href [link]="button.url">
            <button [buttonStyle]="button.style || 'button'"
                    style="width: fit-content;"
                    [class.height-100]="content.matchButtonsHeight">
                <span class="_content"
                      *iCms="'copy' of button"></span>
            </button>
        </href>
        }
    </div>
    }
</div>
}
}